import type { ProductionRun, ProductionReferenceData } from "./models";
import { MaterialScrapSheet } from "./MaterialScrapSheet";
import { useMaterialScrapWorkspace } from "./useMaterialScrapWorkspace";
import { useTerminalSupervisors } from "./useTerminalSupervisors";

export function OperatorMaterialScrapSheet({run,terminalCode,sessionId,operatorId,preview,reasons,close,onSaved}:{
  run:ProductionRun;terminalCode:string;sessionId:string;operatorId:string;preview:boolean;
  reasons:ProductionReferenceData["reasons"];close:()=>void;onSaved:()=>void;
}) {
  const workspace=useMaterialScrapWorkspace({run,terminalCode,sessionId,operatorId,preview,onSaved});
  const supervisors=useTerminalSupervisors(terminalCode,sessionId);
  return <>
    <MaterialScrapSheet run={run} workspace={workspace} reasons={reasons} supervisors={supervisors.items} supervisorsError={supervisors.error} retrySupervisors={supervisors.retry} close={close}/>
  </>;
}
